/**
 * @generated SignedSource<<c1ea368d7368ff1ad32d2d5e0fb8b806>>
 * @relayHash 5f62c435dcac8baaf0c8fe7285050069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd

import type { ConcreteRequest } from 'relay-runtime';
export type ValidateConvertPageToMarkdownModeQuery$variables = {
  cloudId: string;
  contentId: string;
};
export type ValidateConvertPageToMarkdownModeQuery$data = {
  readonly confluence_validateConvertPageToMarkdownMode: {
    readonly isLossless: boolean;
  } | null | undefined;
};
export type ValidateConvertPageToMarkdownModeQuery = {
  response: ValidateConvertPageToMarkdownModeQuery$data;
  variables: ValidateConvertPageToMarkdownModeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluenceValidateConvertPageToMarkdownModeResult",
    "kind": "LinkedField",
    "name": "confluence_validateConvertPageToMarkdownMode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isLossless"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ValidateConvertPageToMarkdownModeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateConvertPageToMarkdownModeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f62c435dcac8baaf0c8fe7285050069",
    "id": "f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd",
    "metadata": {},
    "name": "ValidateConvertPageToMarkdownModeQuery",
    "operationKind": "query",
    "text": "query ValidateConvertPageToMarkdownModeQuery($cloudId:ID!,$contentId:ID!){confluence_validateConvertPageToMarkdownMode(cloudId:$cloudId,contentId:$contentId){isLossless}}"
  }
};
})();

(node as any).hash = "492958e6bac166c062e3d8a2a17a0d5c";

export default node;
